<!-- data-bs-toggle="offcanvas" -->
<button
  class="ethical-resource-btn position-fixed button-warning"
  type="button"
  data-bs-target="#offcanvasExample"
  aria-controls="offcanvasExample"
>
  <img src="assets/icons/erIcon.svg" class="me-1" alt="" />{{ drawerBtn }}
</button>
<div
  class="offcanvas custom-offcanvas"
  tabindex="-1"
  id="offcanvasExample"
  aria-labelledby="offcanvasExampleLabel"
>
  <div class="offcanvas-header">
    <h3 class="offcanvas-title m-0" id="offcanvasExampleLabel">{{ title }}</h3>
    <button
      type="button"
      class="btn-close text-reset"
      data-bs-dismiss="offcanvas"
      aria-label="Close"
    ></button>
  </div>

  <div class="offcanvas-body">
    <ng-content></ng-content>
  </div>
</div>
